<body>

    <!-- ====== POPUP CONTAINER ====== -->
    <div class="popup-container" id="popupContainer">
      <!-- Close Button -->
      <button class="close-btn" id="closeBtn" aria-label="Close popup">
        &times;
      </button>

      <!-- Header / Titles -->
      <div class="popup-header">
        <div class="popup-title-line1">Dear Guest,</div>
        <div class="popup-title-line2">
          Welcome to <span class="highlight-span">Beat22</span>
        </div>
        <div class="popup-subtitle">
          Divine has to say something to you. Listen Now
        </div>
      </div>

      <!-- Video -->
      <div class="video-container">
        <video
          priority src="https://www.w3schools.com/html/mov_bbb.mp4"
          controls
          poster="https://via.placeholder.com/800x450/000000/ffffff?text=Loading+Preview"
        >
          Your browser does not support HTML5 video.
        </video>
      </div>

      <!-- CTA Button -->
      <button class="cta-btn" id="signupBtn">
        Sign up Now!
        <span class="arrow-icon">→</span>
      </button>
    </div>


  </body>
